import React from 'react';

export default function DetailOrganizeReorderPanel({
  visible,
  items = [],
  availableItems = [],
  inputStyle,
  actionBtnStyle,
  searchValue = '',
  onSearchChange,
  searchPlaceholder = 'Search any field',
  searchRowControl = null,
  onDragStart,
  onDrop,
  onDragEnd,
  onMoveUp,
  onMoveDown,
  onRemove,
  renderItemLabel,
  renderAvailableItemLabel,
  getItemKey,
  getAvailableItemKey,
  isItemInSelection,
  onAddItem,
  filterControls = null,
  customSearchRow = null,
  hideSearch = false,
  hideAvailableList = false,
}) {
  if (!visible) return null;
  const hasFilterControls = React.Children.count(filterControls) > 0;

  return (
    <div className="organizer-layout" style={{ padding: '10px', border: '1px solid var(--card-border)', borderRadius: '10px', width: '100%', maxWidth: '760px', margin: '0 auto' }}>
      <div className="organizer-row-full" style={{ maxHeight: '220px', overflowY: 'auto', border: '1px dashed var(--card-border)', borderRadius: '8px', padding: '6px', width: '100%' }}>
        {items.map((item, index) => (
          <div
            key={getItemKey ? getItemKey(item, index) : `${index}`}
            draggable
            onDragStart={() => onDragStart?.(index)}
            onDragOver={(e) => e.preventDefault()}
            onDrop={() => onDrop?.(index)}
            onDragEnd={() => onDragEnd?.()}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 4px', borderBottom: '1px solid color-mix(in srgb, var(--card-border) 65%, transparent)' }}
          >
            <span className="text-scaled">{renderItemLabel ? renderItemLabel(item, index) : (item?.title || '')}</span>
            <span style={{ display: 'inline-flex', gap: '6px' }}>
              <button className="btn-subtle" style={{ ...(actionBtnStyle || {}), cursor: 'grab' }} title="Drag to reorder">⋮⋮</button>
              <button className="btn-subtle" disabled={index === 0} style={actionBtnStyle} onClick={() => onMoveUp?.(index)}>↑</button>
              <button className="btn-subtle" disabled={index === items.length - 1} style={actionBtnStyle} onClick={() => onMoveDown?.(index)}>↓</button>
              <button className="btn-subtle" style={actionBtnStyle} onClick={() => onRemove?.(item, index)}>✕</button>
            </span>
          </div>
        ))}
      </div>
      {customSearchRow ? (
        customSearchRow
      ) : !hideSearch ? (
        searchRowControl ? (
          <div className="organizer-row-two">
            <input
              className="search-input"
              style={{ ...(inputStyle || {}), width: '100%', boxSizing: 'border-box' }}
              value={searchValue}
              onChange={(e) => onSearchChange?.(e.target.value)}
              placeholder={searchPlaceholder}
            />
            {searchRowControl}
          </div>
        ) : (
          <input
            className="search-input organizer-row-full"
            style={{ ...(inputStyle || {}), width: '100%', boxSizing: 'border-box' }}
            value={searchValue}
            onChange={(e) => onSearchChange?.(e.target.value)}
            placeholder={searchPlaceholder}
          />
        )
      ) : null}
      {hasFilterControls && (
        <div className="organizer-row-two">
          {filterControls}
        </div>
      )}
      {!hideAvailableList && (
        <div className="organizer-row-full" style={{ maxHeight: '220px', overflowY: 'auto', border: '1px dashed var(--card-border)', borderRadius: '8px', padding: '6px', backgroundColor: 'var(--input-bg)', width: '100%' }}>
          {availableItems.map((item, index) => {
            const inSelection = isItemInSelection ? isItemInSelection(item) : false;
            return (
              <div
                key={getAvailableItemKey ? getAvailableItemKey(item, index) : `${index}`}
                className="text-scaled"
                style={{
                  padding: '5px 4px',
                  cursor: inSelection ? 'default' : 'pointer',
                  color: inSelection ? 'var(--text-muted)' : 'inherit',
                  fontWeight: inSelection ? 'bold' : 'normal'
                }}
                onClick={() => onAddItem?.(item)}
              >
                {renderAvailableItemLabel ? renderAvailableItemLabel(item) : (item?.title || '')}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
